import { render } from "./ZuLiBuLiangPage.vue?vue&type=template&id=72ef43ec&scoped=true"
import script from "./ZuLiBuLiangPage.vue?vue&type=script&lang=js"
export * from "./ZuLiBuLiangPage.vue?vue&type=script&lang=js"

import "./ZuLiBuLiangPage.vue?vue&type=style&index=0&id=72ef43ec&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ef43ec"]])

export default __exports__